import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import axios from "axios";

import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, Paper, Typography } from "@mui/material";
import CustomPagination from "../../../../component/common/CustomPagination";
import { koKRGrid } from "../../../../component/common/TableKRText";
import api from "../../../../../API";
import AssignMentDialog from  "./AssignMentDialog";
import AssignMentListDialog from  "./AssignMentListDialog";
import { useSelector } from "react-redux";
import { Cell, Pie, PieChart } from "recharts";
import OrgUploadListDialog from "./OrgUploadListDialog";
// import { getCodeNm } from "../../component/common/CodeNm";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatephone(phone: string) {
  const re = /^\(?(\d{3})\)?[- ]?(\d{4})[- ]?(\d{4})$/;
  return re.test(String(phone).toLowerCase());
}

export const conTypeName: { [key: string]: string } = {
  '00': '미분류',
  '01': '경제및산업',
  '02': '사회및제도',
  '03': '문화및라이프',
  '04': '게임및과학',
  '05': '건강및의학',
  '06': '언론및보도',
  '07': '학문및원리',
  '08': '역사및지리',
  '09': '자연및환경',
  '10': '종교및정치',
};

export function getConTypeText(conType: string): string {
  return conTypeName[conType] || '';
}

export const conTypeColor: { [key: string]: string } = {
  '00': '#3e36a5',
  '01': '#a57536',
  '02': '#5fa536',
  '03': '#3694a5',
  '04': '#366fa5',
  '05': '#5436a5',
  '06': '#a136a5',
  '07': '#a5366a',
  '08': '#9ea536',
  '09': '#36a54e',
  '10': '#a53645',
};

export function getConTypeColor(conType: string): string {
  return conTypeColor[conType] || '';
}

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR,
);

export interface roleType {
  role: string;
  type: string;
  use_yn: string;
}

export interface rowDetailType {
  id: number;
  email: string;
  name: string;
  birth: string;
  gender: string;
  jumin: string;
  bank: string;
  bank_num: string;
  phone: string;
  startDate: string;
  roles: roleType[];
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

// piechart
const COLORS = ["#FFBB28", "#03cf5d", "#525cdb", "#FF8042"];
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  payload
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  // console.log('payload',payload)

  return (
    <React.Fragment>
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      // dominantBaseline="central"
      style={{fontSize:"12px",fontWeight:600}}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
    <text
      x={x+15}
      y={y+15}
      fill="black"
      textAnchor={x > cx ? "start" : "end"}
      // dominantBaseline="central"
      style={{fontSize:"10px",fontWeight:600}}
    >
      {`(${payload.value}건)`}
      {/* {`(44,000건)`} */}
    </text>
    </React.Fragment>
  );
};

const MemberAssignmentTable = () => {

  

  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const authCodeList = useSelector((state:any)=> state.code.auth.data)

  const [scriptStatus, setScriptStatus] = useState([]);


  // 할당 팝업
  const [dialogOpen, setDialogOpen] = useState(false);

  // 할당 리스트화면
  const [listDialogOpen, setListDialogOpen] = useState(false);

  // 제출완료 리스트화면
  const [org_uploadDialogOpen, setOrg_uploadDialogOpen] = useState(false);


  const [totalAssignment , setTotalAssignment] = useState(0);
  const [totalNoAssignment , setTotalNoAssignment] = useState(0);
  const [totalOrgUpload , setTotalOrgUpload] = useState(0);

  const getScriptStatus = async () => {
    var result = await api.get("/scriptStatus",{params:{email:email}});
    console.log("할당현황", result.data.datas);
    setScriptStatus(result.data.datas)
    
    const result_data = result.data.datas

    const totalAssignment = result_data.reduce((acc:any, item:any) => acc + item.assignment, 0);

    setTotalAssignment(totalAssignment)

    const totalNoAssignment = result_data.reduce((acc:any, item:any) => acc + item.no_assignment, 0);

    setTotalNoAssignment(totalNoAssignment)

    const totalOrgUpload = result_data.reduce((acc:any, item:any) => acc + item.org_upload, 0);

    setTotalOrgUpload(totalOrgUpload)

    console.log('assignment 합', totalAssignment); // 총 assignment의 합 출력
  };

  useEffect(() => {
    // getMemberList();
    getScriptStatus();
  }, []);

  const [con_type, setCon_type] = useState("");

  const assignMentPage = (con_type:string) => {
    setDialogOpen(true)
    setCon_type(con_type)
  }

  const assignMentListPage = (con_type:string) => {
    setListDialogOpen(true)
    setCon_type(con_type)
  }

  
  const orgUploadListPage = (con_type:string) => {
    setOrg_uploadDialogOpen(true)
    setCon_type(con_type)
  }

  return (
    <Box
      sx={{
        // width: "100%",
        width: "1500px",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"}
        // ".header-style":{
        //   backgroundColor: "#95b1d1",
        //   fontWeight: 600,
        //   color: "#fff"
        // }
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>대화 - 작업할당</h3></Box>
        <Box sx={{ height: "600px", width: "100%" }}>
          {/* <Box sx={{display:"flex", justifyContent:"center"}}> */}
          <Box sx={{display:"flex", justifyContent:"center", fontSize:"32px", fontWeight:600}}>
            <Box sx={{backgroundColor:"blue",color:"#fff",padding:"8px",borderRadius:"5px"}}>총합 : {(totalAssignment + totalNoAssignment + totalOrgUpload)}</Box>
            <Box sx={{marginLeft:"16px",backgroundColor:"#FFBB28",color:"#fff",padding:"8px",borderRadius:"5px"}}>할당전 : {totalNoAssignment}</Box>
            <Box sx={{marginLeft:"16px",backgroundColor:"#03cf5d",color:"#fff",padding:"8px",borderRadius:"5px"}}>할당완료 : {totalAssignment}</Box>
            <Box sx={{marginLeft:"16px",backgroundColor:"#1152a7",color:"#fff",padding:"8px",borderRadius:"5px"}}>제출완료 : {totalOrgUpload}</Box>
          </Box>
          <Box sx={{display:"inline-flex", flexWrap: "wrap", justifyContent:"center"}}>
            {scriptStatus.length > 0 ? scriptStatus.map((script:any,index:any)=>{
              let data = [
                { name: "할당전", value: script.no_assignment },
                { name: "할당완료", value: script.assignment },
                { name: "제출완료", value: script.org_upload },
              ];
              
              return (
              <Paper key={index} sx={{margin:"16px"}}>
                <Box sx={{fontWeight:600,display:"flex",alignItems: "baseline",margin:"8px",backgroundColor:getConTypeColor(script.con_type), color:"#fff", borderRadius:"5px", padding:"4px"}}>
                  <b style={{marginLeft:"8px"}} >{script.con_type+". "}{getConTypeText(script.con_type)}</b>
                  <Box sx={{border:"2px solid #fff",backgroundColor:"#fff",color:"#3e36a5",cursor:"pointer",display: "flex"
                  , justifyContent: "center", alignItems: "center", borderRadius: "33%", fontSize:"14px"
                  , marginLeft:"auto",width:"30px", height:"20px"}}
                  onClick={()=>assignMentPage(script.con_type)}
                  >할당</Box>
                </Box>
                <PieChart width={300} height={300}>
                <Pie
                  isAnimationActive={true}
                  data={data}
                  cx={145}
                  cy={155}
                  labelLine={false}
                  label={renderCustomizedLabel}
                  // label
                  // innerRadius={40}
                  // outerRadius={80}
                  fill="#61d173"
                  nameKey="name"
                  dataKey="value"
                >
                  {data.map((entry: any, index: any) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                      onClick={(e) => console.log(e)}
                    />
                  ))}
                </Pie>
              </PieChart>
              {/* const COLORS = ["#03cf5d", "#525cdb", "#FFBB28", "#FF8042"]; */}
              <Box sx={{fontWeight:500, margin:"8px"}}>
                <Box sx={{display:"flex"}}>
                  <Box>
                    <Box>주제 : {conTypeName[script.con_type] || ''}</Box>
                    <Box><b style={{color:"blue"}}></b>총건수 : <b style={{color:"blue"}}>{script.no_assignment + script.assignment + script.org_upload}</b> 건</Box>
                    <Box><b style={{color:"#FFBB28"}}>●</b>할당전 : <b style={{color:"#FFBB28"}}>{script.no_assignment}</b> 건</Box>
                    <Box><b style={{color:"#03cf5d"}}>●</b>할당완료 : <b style={{color:"#03cf5d"}}>{script.assignment}</b> 건</Box>
                    <Box><b style={{color:"#1152a7"}}>●</b>제출완료 : <b style={{color:"#1152a7"}}>{script.org_upload}</b> 건</Box>
                  </Box>
                  <Box sx={{margin:"auto"}}>
                    <Box sx={{marginLeft:"auto"}}><Button variant="contained" sx={{fontWeight:600, color:"#fff", border:"2px solid #fff", backgroundColor:"#03cf5d", height:"30px", ":hover":{backgroundColor:"#fff", color:"#03cf5d"}}} onClick={()=>assignMentListPage(script.con_type)}>할당 목록</Button></Box>
                    <Box sx={{marginLeft:"auto",marginTop:"8px"}}><Button variant="contained" sx={{fontWeight:600, color:"#fff", border:"2px solid #fff", backgroundColor:"#3e36a5", height:"30px", ":hover":{backgroundColor:"#fff", color:"#3e36a5"}}} onClick={()=>orgUploadListPage(script.con_type)}>완료 목록</Button></Box>
                  </Box>
                </Box>
                
                
              </Box>
            </Paper>
            )}) : ""}
          </Box>
          
        </Box>
        
      </ThemeProvider>

      {dialogOpen == true ? (
        <AssignMentDialog
          con_type={con_type}
          setDialogOpen={setDialogOpen}
          getScriptStatus={getScriptStatus}
          />
          ) : ""}
      {listDialogOpen == true ? (
        <AssignMentListDialog
          // dialogOpen={dialogOpen}
          con_type={con_type}
          setListDialogOpen={setListDialogOpen}
          />
          ) : ""}
      {org_uploadDialogOpen == true ? (
        <OrgUploadListDialog
          // dialogOpen={dialogOpen}
          con_type={con_type}
          setOrg_uploadDialogOpen={setOrg_uploadDialogOpen}
          />
          ) : ""}
        </Box>
      );
    };
export default MemberAssignmentTable;
